import { translate, useDynamicData } from '@avensia/excite';
import { styled } from '@glitz/react';
import { Button } from 'webapp/components/button';
import { TestIdProps } from '@avensia/test-automation';
import { Theme } from 'webapp/theme';
import * as React from 'react';
import { NnTestIdProps } from 'webapp/shared/test-ids';
import { useFlyout } from 'webapp/shell/flyout-context';
import { CartIcon } from 'webapp/components/icons';

export function CartButton() {
  const { open } = useFlyout('Cart');
  const [itemCount] = useDynamicData<Excite.Commercetools.CartApiModel, number>({ selector: cartItemsSelector });
  const [runAnimation, setRunAnimation] = React.useState(false);

  React.useEffect(() => {
    setRunAnimation(true);
  }, [itemCount]);

  return (
    <IconButton
      square
      disableRippleEffect
      as={Theme.Transparent}
      onClick={open}
      aria-label={translate(t => t.header.cart)}
      title={translate(t => t.header.youHaveXItemsInCart, { itemCount })}
      {...NnTestIdProps.HeaderCartIcon}
    >
      <CartIcon {...TestIdProps.MiniCartLink} />
      {itemCount > 0 && (
        <ItemCount
          css={runAnimation && pulseAnimationDecorator}
          onAnimationEnd={() => setRunAnimation(false)}
          {...NnTestIdProps.HeaderCartIconCount}
        >
          {itemCount}
        </ItemCount>
      )}
    </IconButton>
  );
}

export function cartItemsSelector(data?: Excite.Commercetools.CartApiModel) {
  return data?.items?.reduce((a, b) => a + b.quantity, 0) ?? 0;
}

const pulseAnimationDecorator = styled({
  animation: {
    name: {
      '0%': {
        boxShadow: t => `0 0 0 0 ${t.headerIndicators.cart.backgroundColor}61`,
      },
      '70%': {
        boxShadow: t => `0 0 0 10px ${t.headerIndicators.cart.backgroundColor}00`,
      },
      '100%': {
        boxShadow: t => `0 0 0 0 ${t.headerIndicators.cart.backgroundColor}00`,
      },
    },
    duration: 2000,
  },
});

const IconButton = styled(Button, {
  position: 'relative',
  overflow: 'visible',
});

const ItemCount = styled.span({
  color: t => t.headerIndicators.cart.color,
  backgroundColor: t => t.headerIndicators.cart.backgroundColor,
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 20,
  width: 20,
  top: 4,
  right: 4,
  borderRadius: '50%',
  fontSize: t => t.sharedFontSize.xxxs,
});
